import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import Popup from 'reactjs-popup';
import styled from 'styled-components';
import { Label } from 'semantic-ui-react';

import { closeModal } from 'actions/modal';
import {
  patch as expireTeacherSlot,
  invalidateItem as invalidateTeacherSlot,
} from 'actions/teacher-slots';
import { patch as expireStudentSlot } from 'actions/student-unique-slots';
import { CellText } from 'comps/styled-text';
import { getStatusData } from 'utils/slot-calendar';

import SlotDataPopUp from './slot-data-popup';

const SlotCellWrapper = styled.div`
  margin-top: 10px;
  text-align: center;
  margin-bottom: 10px;
`;

const CellTextWrapperDay = styled(CellText)`
  size: small;
  font-weight: 600;
  align-self: center;
`;

class SlotData extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      expireStudentSlot: PropTypes.func.isRequired,
      expireTeacherSlot: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
      invalidateTeacherSlot: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showPopupTeacher: true,
      showPopupStudent: true,
      expireType: null,
      expireId: null,
      studentPatch: store.patch(),
      teacherPatch: store.patch(),
      invalidateSlot: true,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { studentUniqueSlots, teacherSlots, actions, teacher } = props;
    const { teacherPatch, studentPatch, invalidateSlot } = state;
    const newStudentPatch = store.patch(studentUniqueSlots, studentPatch.id) || {};
    const newTeacherPatch = store.patch(teacherSlots, teacherPatch.id) || {};
    const { resolved: teacherPatchResolved } = newTeacherPatch || {};
    const newState = {};

    if (newStudentPatch.resolved) {
      if (newStudentPatch.resolved.isPatched && invalidateSlot) {
        actions.invalidateTeacherSlot(teacher.id);
        newState.invalidateSlot = false;
        alert('Slot Updated Successfully');
      } else if (newStudentPatch.resolved.isPatchingFailed) {
        newState.studentPatch = newStudentPatch;
        newState.invalidateSlot = false;
        alert(store.getError(newStudentPatch.resolved).message);
      }
    }

    if (teacherPatchResolved) {
      if (teacherPatchResolved.isPatched && invalidateSlot) {
        actions.invalidateTeacherSlot(teacher.id);
        newState.invalidateSlot = false;
        alert('Slot Updated Successfully');
      } else if (teacherPatchResolved.isPatchingFailed) {
        newState.newTeacherPatch = newTeacherPatch;
        newState.invalidateSlot = false;
        alert(store.getError(teacherPatchResolved).message);
      }
    }

    return newState;
  }

  onTeacherClick = (data, teacherSlotId) => {
    const { actions } = this.props;
    const {
      teacherPatch: { id },
    } = this.state;
    actions.expireTeacherSlot(id, teacherSlotId, {
      action: data,
      teacherSlotId: teacherSlotId,
    });
  };

  slotCell = (data, total) => {
    let statusData = getStatusData(data);
    return (
      <SlotCellWrapper>
        <Label size="mini" key={statusData.color} color={statusData.color}>
          {statusData.title}
          <Label.Detail>{total}</Label.Detail>
        </Label>
      </SlotCellWrapper>
    );
  };

  render() {
    const { data, batchView } = this.props;
    const { $$typeof: domElement, status, student_slots_count: studentSlotsCount } =
      data || {};

    const isBatchDataStatusEXP = status === 'EXP';

    if (isBatchDataStatusEXP) {
      return '';
    }

    if (!isBatchDataStatusEXP && !domElement) {
      return (
        <div>
          <Popup
            trigger={() => this.slotCell(data, studentSlotsCount)}
            on={!batchView ? 'click' : null}
            closeOnDocumentClick
            modal
            contentStyle={{ width: '20%', border: '1px solid #333' }}
          >
            <SlotDataPopUp slotData={data} onTeacherClick={this.onTeacherClick} />
          </Popup>
        </div>
      );
    }

    return <CellTextWrapperDay>{data}</CellTextWrapperDay>;
  }
}

export default connect(
  ({ studentUniqueSlots, teacherSlots }) => ({ studentUniqueSlots, teacherSlots }),
  dispatch => ({
    actions: bindActionCreators(
      {
        expireStudentSlot,
        expireTeacherSlot,
        closeModal,
        invalidateTeacherSlot,
      },
      dispatch,
    ),
  }),
)(SlotData);
